import * as React from "react";

import {Link} from "react-router-dom";
import {Button, Icon, Spin, Tooltip, message} from 'antd';

import {ICourse} from "../../model/Course";
import Firebase, {withFirebase, UserContext} from '../../components/Firebase';
import {IUser} from '../../model/User';

// ga events
import {gaCourseStarClicked} from '../../ga/course';
import * as ReactGA from 'react-ga';


interface IProps {
  firebase: Firebase;
  courseSlug: string;
}

interface IState {
  course: ICourse | 'loading';
}

class CourseInfo extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
      course: 'loading',
    }
  }

  componentDidMount(): void {
    this.getCourseInfo();
  }

  async getCourseInfo() {
    const doc = await this.props.firebase.getCourse(this.props.courseSlug);
    if (doc.exists) {
      const course: ICourse = doc.data() as ICourse;
      if (!course) {return;}
      this.setState(() => ({course}));
    }
  }


  addCourseToFavorites = async(e: any, remove = false) => {
    gaCourseStarClicked(remove);
    try {
      await this.props.firebase.addCourseToUser(this.props.courseSlug, remove);
      this.openNotificationWithIcon('success', remove);
    } catch (e) {
      console.log(e);
    }

  }

  openNotificationWithIcon(type: string, remove: boolean) {
    message.success(remove ? 'Removed course from your list' : 'Course added to your list');
  };


  public render() {
    const {course} = this.state;

    if (!course) {
      return 'no such course';
    }
    if (course === 'loading') {
      return <Spin />;
    }

    const starButton = (() => {
      return(
        <UserContext.Consumer>
          { (user: IUser) => {
            if (!user) {
              return;
            }

            let theme: 'outlined' | 'filled' = 'outlined';
            let title = 'Add to my list';
            let action = this.addCourseToFavorites;
            if (user.courses.indexOf(this.props.courseSlug) > -1) {
              theme = 'filled';
              title = 'Remove from my list';
              action = this.addCourseToFavorites.bind(this, true)
            }
            return (
            <Tooltip title={title}>
              <Icon type='star' theme={theme} className='frs' style={{fontSize:'24px', color: '#346cb0'}}
                         onClick={action}/>
            </Tooltip>)
          }}
        </UserContext.Consumer>
      )
    })();

    return (
      <div>
        <h3>
          {course.name}  {starButton}

          <Link to={`/courses/${course.slug}/chat`} className='fr'>
            <Button type='primary'>Enter Chat</Button>
          </Link>
        </h3>
        <p className='secondary-text'>{course.code} {course.academicLevel}</p>
        <p>{course.description}</p>
        <p>
          <Tooltip title='5 - most difficult, 1 - easy'>
            Difficulty: <strong>{course.avgDifficulty ? course.avgDifficulty.toFixed(2) : 'N/A '} </strong>
          </Tooltip>
          <Tooltip title='5 - very useful, 1 - useless'>
            &bull; Usefulness: <strong>{course.avgUsefulness ? course.avgUsefulness.toFixed(2) : 'N/A'}</strong>
          </Tooltip>
          {course.feedbacksCount ?
            <span> based on <strong>{course.feedbacksCount}</strong> {course.feedbacksCount > 1 ? 'feedbacks' : 'feedback'} </span>
            : ''}
        </p>

      </div>
    );
  }

}

export default withFirebase(CourseInfo);